
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Jp28", function(module, exports) {
/* PagePropertiesReportRenderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $3u5lg = parcelRequire("3u5lg");


var $9DHhW = parcelRequire("9DHhW");


var $hRnS5 = parcelRequire("hRnS5");


var $I7hWB = parcelRequire("I7hWB");


var $9KSWX = parcelRequire("9KSWX");


var $4kJeN = parcelRequire("4kJeN");


var $l8Rhq = parcelRequire("l8Rhq");


var $buxP3 = parcelRequire("buxP3");


var $lfoFx = parcelRequire("lfoFx");


var $9JU7l = parcelRequire("9JU7l");


var $8pcS0 = parcelRequire("8pcS0");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");


var $cXk0q = parcelRequire("cXk0q");




const $6f15b8e4eedd18d1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    comments: {
        id: "page-properties-report-renderer.table.comments",
        defaultMessage: "Comments"
    },
    owner: {
        id: "page-properties-report-renderer.table.owner",
        defaultMessage: "Owner"
    },
    errorMessage: {
        id: "page-properties-report-renderer.error.message",
        defaultMessage: "Unable to display this report. Refresh and try again."
    },
    generatingReport: {
        id: "page-properties-report-renderer.loading.message",
        defaultMessage: "Generating Page Properties Report..."
    },
    generatingContentPropertiesReport: {
        id: "page-properties-report-renderer.loading.message.content-properties",
        defaultMessage: "Generating content properties report..."
    },
    labels: {
        id: "page-properties-report-renderer.table.labels",
        defaultMessage: "Labels"
    },
    modified: {
        id: "page-properties-report-renderer.table.modified",
        defaultMessage: "Modified"
    },
    noContent: {
        id: "page-properties-report-renderer.noContent",
        defaultMessage: "No content found"
    },
    reactions: {
        id: "page-properties-report-renderer.table.reactions",
        defaultMessage: "Reactions"
    },
    title: {
        id: "page-properties-report-renderer.table.title",
        defaultMessage: "Title"
    },
    unresolvedComments: {
        id: "page-properties-report-renderer.table.unresolvedComments",
        defaultMessage: "Unresolved comments"
    }
});


const $1258cdefca585133$export$84581618425b912b = ({ contentId: contentId, createAnalyticsEvent: createAnalyticsEvent })=>{
    return (adf)=>{
        if (adf) try {
            return JSON.parse(adf);
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'error',
                    actionSubject: 'pagePropertiesReport',
                    source: 'parseADF',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        }
        return {
            version: 1,
            type: 'doc',
            content: []
        };
    };
};


var $isgNA = parcelRequire("isgNA");

var $4XbfY = parcelRequire("4XbfY");


var $j9MAI = parcelRequire("j9MAI");


var $at1wf = parcelRequire("at1wf");

const $4864bed890a7c5e2$export$4c4a3e752688c55f = (labels)=>{
    const names = labels.map((label)=>label?.name || '');
    return ''.concat(...names);
};


const $789bcdd2555ad126$export$50a12e0b15e63c30 = (a, b, sortColumn)=>{
    switch(sortColumn){
        case 'showCommentsCount':
            return [
                a.commentsCount,
                b.commentsCount
            ];
        case 'pageTitle':
            return [
                a.title,
                b.title
            ];
        case 'showCreator':
            return [
                a.creator?.name || '',
                b.creator?.name || ''
            ];
        case 'showLastModified':
            return [
                a.lastModified?.sortableDate || '',
                b.lastModified?.sortableDate || ''
            ];
        case 'showLikesCount':
            return [
                a.reactionsCount,
                b.reactionsCount
            ];
        case 'showPageLabels':
            return [
                (0, $4864bed890a7c5e2$export$4c4a3e752688c55f)(a.labels),
                (0, $4864bed890a7c5e2$export$4c4a3e752688c55f)(b.labels)
            ];
        case 'showUnresolvedCommentsCount':
            return [
                a.unresolvedCommentsCount,
                b.unresolvedCommentsCount
            ];
        default:
            // prevents sort if given a bad sort column value
            return [
                1,
                1
            ];
    }
};



const $bf0d65ab8dbaa895$var$isNumeric = (num)=>(typeof num === 'number' || typeof num === 'string' && num.trim() !== '') && !isNaN(num);
const $bf0d65ab8dbaa895$var$compareStringsForSort = (stringA, stringB, sortOrder)=>{
    if (sortOrder === 'ascending') return stringA.localeCompare(stringB, undefined, {
        numeric: $bf0d65ab8dbaa895$var$isNumeric(stringA) && $bf0d65ab8dbaa895$var$isNumeric(stringB)
    });
    else return stringB.localeCompare(stringA, undefined, {
        numeric: $bf0d65ab8dbaa895$var$isNumeric(stringA) && $bf0d65ab8dbaa895$var$isNumeric(stringB)
    });
};
const $bf0d65ab8dbaa895$export$bc58d7f8cf8938c3 = ({ adfHeaderIndex: adfHeaderIndex, contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, rows: rows, sortHeader: sortHeader, sortOrder: sortOrder })=>{
    if (sortOrder === undefined) return rows;
    const adfParser = (0, $1258cdefca585133$export$84581618425b912b)({
        contentId: contentId,
        createAnalyticsEvent: createAnalyticsEvent
    });
    // Cache the parsed ADF to avoid redundant parsing and doc rendering on subsequent sort comparisons
    const cache = new Map();
    return rows.slice().sort((a, b)=>{
        if (!a || !b) return 0;
        // adfHeaderIndex would only be defined when an adf column header is clicked
        if (adfHeaderIndex !== undefined) {
            // turn ADF into plain text in order to compare the strings more accurately
            const textSerializer = new (0, $at1wf.default)((0, $4XbfY.defaultSchema));
            const textA = cache.get(a.details[adfHeaderIndex]) || ((0, $j9MAI.renderDocument)(adfParser(a.details[adfHeaderIndex]), textSerializer).result ?? '');
            const textB = cache.get(b.details[adfHeaderIndex]) || ((0, $j9MAI.renderDocument)(adfParser(b.details[adfHeaderIndex]), textSerializer).result ?? '');
            cache.set(a.details[adfHeaderIndex], textA);
            cache.set(b.details[adfHeaderIndex], textB);
            return $bf0d65ab8dbaa895$var$compareStringsForSort(textA, textB, sortOrder);
        }
        const [aSort, bSort] = (0, $789bcdd2555ad126$export$50a12e0b15e63c30)(a, b, sortHeader);
        if (typeof aSort === 'string' && typeof bSort === 'string') return $bf0d65ab8dbaa895$var$compareStringsForSort(aSort, bSort, sortOrder);
        else if (typeof aSort === 'number' && typeof bSort === 'number') return sortOrder === 'ascending' ? aSort - bSort : bSort - aSort;
        else return 0;
    });
};



var $bDgLe = parcelRequire("bDgLe");








var $1VhsF = parcelRequire("1VhsF");


const $67275e94a078679f$export$c1ed4f415b9e7023 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).errorMessage));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};

/* HeaderPressable.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $kh0hi = parcelRequire("kh0hi");


var $9wGTI = parcelRequire("9wGTI");

'use no memo';
const $8302664fa090dd98$var$sortIconBaseStylesFallback = null;
const $8302664fa090dd98$var$sortIconBaseStylesTokenized = null;
const $8302664fa090dd98$var$sortIconAscendingStylesFallback = null;
const $8302664fa090dd98$var$sortIconAscendingStylesTokenized = null;
const $8302664fa090dd98$var$sortIconDescendingStylesFallback = null;
const $8302664fa090dd98$var$sortIconDescendingStylesTokenized = null;
const $8302664fa090dd98$var$headerPressableStyles = (0, $buxP3.xcss)({
    background: 'none',
    font: 'font.body.large',
    fontWeight: 'font.weight.bold',
    color: 'color.text',
    display: 'flex',
    gap: 'space.100'
});
const $8302664fa090dd98$export$518cc0dd87420e7c = ({ children: children, sortOrder: sortOrder, ...pressableProps })=>{
    return(// TODO: Update the attribute below so it is translated.
    // eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        "aria-roledescription": "Sort button",
        xcss: $8302664fa090dd98$var$headerPressableStyles,
        ...pressableProps
    }, children, (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "page-properties-report-sort-icon",
        "data-sort-order": sortOrder,
        className: (0, $hekY6.default)([
            !!sortOrder && "_1mT5xdRAKS _2KinTkjOvk _1nRsHk6wH8 _0eGJOxvc3e _1KeLlNfu0z _0OU75rvLZJ _3ScelFdnbC _1lBcDcdnbC _3dCYwDWVPG _3Ku51Iogpp _3p3AmI2ADO _3ljX6P4F84 _35I30BXJux _0z8nYCjOvk _4lwhQT6wH8 _0dpm39vc3e _3zftirfu0z _4Gb5FivLZJ _2jfUf9dnbC _47eTBtdnbC _2WYcYGWVPG _0GBAIrogpp _3ufiZDdnbC _3erkSQ4F84 _2KaDuOEbN9",
            !!sortOrder && sortOrder === 'ascending' && "_1KeLlNPtGO",
            !!sortOrder && sortOrder === 'descending' && "_3zftirPtGO"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "page-properties-report-sort-icon",
        "data-sort-order": sortOrder,
        className: (0, $hekY6.default)([
            !!sortOrder && "_1mT5xdRAKS _2KinTkjOvk _1nRsHk6wH8 _0eGJOx4Y4b _1KeLlNZDwQ _0OU75rvLZJ _3ScelFdnbC _1lBcDcdnbC _3dCYwDWVPG _3Ku51Iogpp _3p3AmI2ADO _3ljX6P4F84 _35I30BXJux _0z8nYCjOvk _4lwhQT6wH8 _0dpm394Y4b _3zftirZDwQ _4Gb5FivLZJ _2jfUf9dnbC _47eTBtdnbC _2WYcYGWVPG _0GBAIrogpp _3ufiZDdnbC _3erkSQ4F84 _2KaDuOEbN9",
            !!sortOrder && sortOrder === 'ascending' && "_1KeLlNNaE4",
            !!sortOrder && sortOrder === 'descending' && "_3zftirNaE4"
        ])
    })));
};


'use no memo';
const $549767e33d06d7f8$var$TableRow = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1x1D3gOeNX",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $549767e33d06d7f8$var$LabelsList = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1LMyvKOiJt _2Zuz6QDqSm",
            __cmplp.className
        ])
    });
}); // Prevents the parent extension-overflow-wrapper's overflowX: 'auto' (editor-common) from
const $549767e33d06d7f8$var$pagePropertiesReportStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $549767e33d06d7f8$var$TableWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $549767e33d06d7f8$var$Table = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$TableBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1x1D3gYbGa _3BR6lmYbGa",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$TableHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1kk5TkdRv1 _0KLXru5Hzd _20VacPYbGa _0wOv4Q7zJH _1eOmH67GA7",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$TableCell = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEZhBx _1EqgXl4DOi _1RrJLiBwqQ",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$OptionalTableCell = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $549767e33d06d7f8$var$TableCell, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4ouGXIIZbP",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$PaginationWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEzcuf _3iDTPbQ4SZ _37wbyuDIqT _4ouGXIdnbC _0vn0jVAASz _0zHK4GAASz _3BPrCVAASz _3wIvMsAASz _2GAy1ZAASz",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$SpinnerWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT _0pI6nMDIqT _3iDTPbgBM8",
            __cmplp.isLoading ? "_0fKRyPYvD1" : "_0fKRyPnQyn",
            __cmplp.className
        ])
    });
});
const $549767e33d06d7f8$var$anchorStyles = (0, $buxP3.xcss)({
    textDecoration: 'none'
});
const $549767e33d06d7f8$var$convertPPRRendererProps = (isLegacyRenderer, rendererProps)=>{
    if (!isLegacyRenderer) return rendererProps;
    return {
        adf: rendererProps.document,
        objectId: rendererProps.contentId,
        contentType: rendererProps.contentType
    };
};
const $549767e33d06d7f8$var$hasMacroExtensionNode = (node)=>{
    if (!node || typeof node !== 'object') return false;
    if ((node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) || node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE) || node.type === (0, $8pcS0.INLINE_EXTENSION_TYPE) || node.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) && node.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE) return true;
    return Array.isArray(node.content) && node.content.some($549767e33d06d7f8$var$hasMacroExtensionNode);
};
const $549767e33d06d7f8$export$cf18f6d3d78db54e = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, openAnchorsInNewTab: openAnchorsInNewTab = false, Renderer: Renderer, isLegacyRenderer: isLegacyRenderer = false })=>{
    const [sortHeader, setSortHeader] = (0, $cozmU.useState)('');
    const [sortOrder, setSortOrder] = (0, $cozmU.useState)();
    const [currentAdfSortHeaderIndex, setCurrentAdfSortHeaderIndex] = (0, $cozmU.useState)();
    const { data: data, error: error, isInitialLoad: isInitialLoad, isPDFExport: isPDFExport, loading: loading, pageIndex: pageIndex, paginateTable: paginateTable, totalPages: totalPages } = (0, $cXk0q.useDetailsSummaryADFQuery)({
        macroDefaultProps: macroDefaultProps,
        macroParams: macroParams
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, contentType: contentType, spaceId: spaceId, spaceKey: spaceKey } = macroDefaultProps;
    const optionalColumnsToShow = (0, $cozmU.useMemo)(()=>(0, $isgNA.optionalTableHeaderParams).filter((currentHeaderParam)=>macroParams?.[currentHeaderParam]?.value === 'true'), [
        macroParams
    ]);
    const adfParser = (0, $1258cdefca585133$export$84581618425b912b)({
        contentId: contentId,
        createAnalyticsEvent: createAnalyticsEvent
    });
    const handleHeaderClick = (header, adfHeaderIndex)=>{
        setSortHeader(header);
        setSortOrder((prevSortOrder)=>// default to ascending sort when changing between sort columns and when first sorting
            header !== sortHeader || prevSortOrder !== 'ascending' ? 'ascending' : 'descending');
        setCurrentAdfSortHeaderIndex(adfHeaderIndex);
    };
    const getSortOrder = (headerName)=>sortHeader === headerName ? sortOrder : undefined;
    const getOptionalColumnHeaders = (header_0)=>{
        switch(header_0){
            case 'showCommentsCount':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                    "aria-sort": getSortOrder('showCommentsCount'),
                    key: "comments-table-header",
                    onClick: ()=>handleHeaderClick('showCommentsCount')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                    sortOrder: getSortOrder('showCommentsCount')
                }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).comments)));
            case 'showCreator':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                    "aria-sort": getSortOrder('showCreator'),
                    key: "creator-table-header",
                    onClick: ()=>handleHeaderClick('showCreator')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                    sortOrder: getSortOrder('showCreator')
                }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).owner)));
            case 'showLastModified':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                    "aria-sort": getSortOrder('showLastModified'),
                    key: "last-modified-table-header",
                    onClick: ()=>handleHeaderClick('showLastModified')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                    sortOrder: getSortOrder('showLastModified')
                }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).modified)));
            case 'showLikesCount':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                    "aria-sort": getSortOrder('showLikesCount'),
                    key: "reactions-table-header",
                    onClick: ()=>handleHeaderClick('showLikesCount')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                    sortOrder: getSortOrder('showLikesCount')
                }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).reactions)));
            case 'showPageLabels':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                    "aria-sort": getSortOrder('showPageLabels'),
                    key: "labels-table-header"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                    onClick: ()=>handleHeaderClick('showPageLabels'),
                    sortOrder: getSortOrder('showPageLabels')
                }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).labels)));
            case 'showUnresolvedCommentsCount':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                    "aria-sort": getSortOrder('showUnresolvedCommentsCount'),
                    key: "unresolved-table-header",
                    onClick: ()=>handleHeaderClick('showUnresolvedCommentsCount')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                    sortOrder: getSortOrder('showUnresolvedCommentsCount')
                }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).unresolvedComments)));
            default:
                return undefined;
        }
    };
    const generateTableHeaders = ({ customTitleHeader: customTitleHeader, optionalColumnsToShow: optionalColumnsToShow_0, tableHeaders: tableHeaders })=>{
        const titleColumnHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
            key: "title-table-header",
            "aria-sort": getSortOrder('pageTitle'),
            onClick: ()=>handleHeaderClick('pageTitle')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
            sortOrder: getSortOrder('pageTitle')
        }, customTitleHeader || formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).title)));
        const baseHeaders = tableHeaders.map((headerADF, idx)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableHeader, {
                key: `${headerADF}-${idx}`,
                "data-testid": "page-properties-report-table-header",
                "aria-sort": getSortOrder(`baseHeader-${idx}`),
                onClick: ()=>handleHeaderClick(`baseHeader-${idx}`, idx)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8302664fa090dd98$export$518cc0dd87420e7c), {
                sortOrder: getSortOrder(`baseHeader-${idx}`)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9JU7l.ADFRendererWithExtensions), {
                appearance: "full-width",
                document: adfParser(headerADF),
                spaceId: spaceId,
                spaceKey: spaceKey
            })));
        });
        const optionalHeaders = optionalColumnsToShow_0.map(getOptionalColumnHeaders).filter((header_1)=>header_1 !== undefined);
        return [
            titleColumnHeader,
            ...baseHeaders,
            ...optionalHeaders
        ];
    };
    const getOptionalCells = (0, $cozmU.useCallback)((header_2, rowContent, rowNumber)=>{
        switch(header_2){
            case 'showCommentsCount':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$OptionalTableCell, {
                    "data-testid": "page-properties-report-comment-cell",
                    key: `comment-cell-row-${rowNumber}`
                }, rowContent.commentsCount > 0 && rowContent.commentsCount);
            case 'showCreator':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$OptionalTableCell, {
                    "data-testid": "page-properties-report-owner-cell",
                    key: `creator-cell-row-${rowNumber}`
                }, rowContent?.creator?.accountId && rowContent?.creator?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
                    href: (0, $5t3NX.getNavigateToTeamsApp)(orgId ?? '', {
                        type: 'USER',
                        payload: {
                            userId: rowContent.creator.accountId
                        }
                    }).href,
                    ...openAnchorsInNewTab && {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    xcss: $549767e33d06d7f8$var$anchorStyles
                }, rowContent.creator.name));
            case 'showLastModified':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$OptionalTableCell, {
                    "data-testid": "page-properties-report-modified-cell",
                    key: `last-modified-date-cell-row-${rowNumber}`
                }, rowContent.lastModified?.friendlyModificationDate);
            case 'showLikesCount':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$OptionalTableCell, {
                    "data-testid": "page-properties-reactions-cell",
                    key: `reactions-cell-row-${rowNumber}`
                }, rowContent.reactionsCount > 0 && rowContent.reactionsCount);
            case 'showPageLabels':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$OptionalTableCell, {
                    "data-testid": "page-properties-report-labels-cell",
                    key: `labels-cell-row-${rowNumber}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$LabelsList, null, rowContent.labels.map((label, idx_0)=>label?.urlPath && label?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
                        key: `${label.urlPath}-${idx_0}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
                        href: `/wiki${label.urlPath}`,
                        ...openAnchorsInNewTab && {
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        },
                        xcss: $549767e33d06d7f8$var$anchorStyles
                    }, label.name))))));
            case 'showUnresolvedCommentsCount':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$OptionalTableCell, {
                    "data-testid": "page-properties-report-unresolved-comment-cell",
                    key: `unresolved-comment-row-${rowNumber}`
                }, rowContent.unresolvedCommentsCount > 0 && rowContent.unresolvedCommentsCount);
            default:
                return undefined;
        }
    }, [
        openAnchorsInNewTab,
        orgId
    ]);
    const generateOptionalBodyCells = (0, $cozmU.useCallback)((optionalColumnsToShow_1, rowContent_0)=>optionalColumnsToShow_1.map((column, rowNumber_0)=>getOptionalCells(column, rowContent_0, rowNumber_0)), [
        getOptionalCells
    ]);
    const generateTableBody = (0, $cozmU.useCallback)(({ tableContent: tableContent, optionalColumnsToShow: optionalColumnsToShow_2, sortHeader: sortHeader_0, sortOrder: sortOrder_0, currentAdfSortHeaderIndex: currentAdfSortHeaderIndex_0 })=>{
        if (!tableContent) return;
        if (tableContent.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableCell, {
            "data-testid": "page-properties-report-no-results-cell"
        }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).noContent)));
        return (0, $bf0d65ab8dbaa895$export$bc58d7f8cf8938c3)({
            rows: tableContent,
            sortOrder: sortOrder_0,
            sortHeader: sortHeader_0,
            adfHeaderIndex: currentAdfSortHeaderIndex_0,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId
        }).map((reportBodyRow, idx_1)=>{
            if (!reportBodyRow) return;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableRow, {
                key: `${reportBodyRow.id}-row-${idx_1}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableCell, {
                "data-testid": "page-properties-report-title-cell",
                key: `title-table-cell-${reportBodyRow.relativeLink}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
                href: `/wiki${reportBodyRow.relativeLink}`,
                ...openAnchorsInNewTab && {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                },
                xcss: $549767e33d06d7f8$var$anchorStyles
            }, reportBodyRow.title)), reportBodyRow.details.map((reportBodyCol, idx_2)=>{
                const reportBodyRowContentId = reportBodyRow.id.toString();
                const parsedReportBodyCol = reportBodyCol ? adfParser(reportBodyCol) : undefined;
                const shouldUseParentRenderer = Boolean(Renderer && parsedReportBodyCol && (0, $6mKj3.expValEquals)('page_properties_connect_to_forge_macro_render', 'isEnabled', true) && $549767e33d06d7f8$var$hasMacroExtensionNode(parsedReportBodyCol));
                const CellRenderer = shouldUseParentRenderer ? Renderer : (0, $9JU7l.ADFRendererWithExtensions);
                const cellRendererProps = shouldUseParentRenderer ? $549767e33d06d7f8$var$convertPPRRendererProps(isLegacyRenderer, {
                    contentId: reportBodyRowContentId,
                    contentType: contentType,
                    document: parsedReportBodyCol
                }) : {
                    contentId: reportBodyRowContentId,
                    document: parsedReportBodyCol
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableCell, {
                    key: `${reportBodyCol}-cell-${idx_2}`
                }, reportBodyCol && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CellRenderer, {
                    ...cellRendererProps,
                    appearance: "full-width",
                    spaceId: spaceId,
                    spaceKey: spaceKey
                })));
            }), generateOptionalBodyCells(optionalColumnsToShow_2, reportBodyRow));
        });
    }, [
        adfParser,
        contentType,
        createAnalyticsEvent,
        contentId,
        formatMessage,
        generateOptionalBodyCells,
        isLegacyRenderer,
        openAnchorsInNewTab,
        Renderer,
        spaceId,
        spaceKey
    ]);
    const tableRows = (0, $cozmU.useMemo)(()=>generateTableBody({
            tableContent: data?.detailsLines?.detailLines,
            optionalColumnsToShow: optionalColumnsToShow,
            sortHeader: sortHeader,
            sortOrder: sortOrder,
            currentAdfSortHeaderIndex: currentAdfSortHeaderIndex
        }), [
        data?.detailsLines?.detailLines,
        generateTableBody,
        optionalColumnsToShow,
        sortHeader,
        sortOrder,
        currentAdfSortHeaderIndex
    ]);
    if (isInitialLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, formatMessage((0, $6f15b8e4eedd18d1$export$a7357cdd1f0b0168).generatingContentPropertiesReport));
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67275e94a078679f$export$c1ed4f415b9e7023), null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_4bt5LAoWuR _2WAcuGoWuR",
            "page-properties-report"
        ]),
        "data-testid": "page-properties-report-macro-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$Table, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("thead", {
        "data-testid": "page-properties-report-table-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("tr", null, generateTableHeaders({
        tableHeaders: data?.detailsLines?.renderedHeadings || [],
        optionalColumnsToShow: optionalColumnsToShow,
        customTitleHeader: macroParams?.firstcolumn?.value
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$TableBody, {
        "data-testid": "page-properties-report-table-body"
    }, tableRows))), totalPages > 1 && !isPDFExport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$PaginationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4kJeN.default), {
        onChange: paginateTable,
        pages: Array.from({
            length: totalPages
        }, (_, i)=>i + 1),
        selectedIndex: pageIndex,
        testId: "page-properties-report-pagination"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$var$SpinnerWrapper, {
        isLoading: loading,
        "data-testid": "page-properties-report-pagination-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "page-properties-report-pagination"
    }))));
};
const $549767e33d06d7f8$export$7cf7439e5d7797c5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireRenderingError = (error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: 'pagePropertiesReport',
                source: 'PagePropertiesReportRenderer',
                objectId: props.macroDefaultProps.contentId,
                attributes: {
                    error: error.message,
                    stack: error.stack
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        onError: fireRenderingError,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67275e94a078679f$export$c1ed4f415b9e7023), null),
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($549767e33d06d7f8$export$cf18f6d3d78db54e, props));
}, // we want to minimize rerenders due to shallow prop comparisons bc of how expensive it is to rerender so many renderer components
(prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevProps, nextProps));
module.exports["PagePropertiesReport"] = $549767e33d06d7f8$export$cf18f6d3d78db54e;
module.exports["PagePropertiesReportRenderer"] = $549767e33d06d7f8$export$7cf7439e5d7797c5;

});

parcelRegister("9JU7l", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $dfd2cf8e7a91698f$export$d0545564fef5423e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3F95d",
    name: "ADFRendererWithExtensions",
    loader: async ()=>(await (parcelRequire("jM8WR"))).ADFRendererWithExtensions
});
module.exports["ADFRendererWithExtensions"] = $dfd2cf8e7a91698f$export$d0545564fef5423e;

});

parcelRegister("jM8WR", function(module, exports) {

let $e65970f75ad80b7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e65970f75ad80b7e$var$load("dZsGY"),
    $e65970f75ad80b7e$var$load("2TRyz"),
    $e65970f75ad80b7e$var$load("lXUHS"),
    $e65970f75ad80b7e$var$load("7jwjb"),
    $e65970f75ad80b7e$var$load("cenKA"),
    $e65970f75ad80b7e$var$load("cYpLS"),
    $e65970f75ad80b7e$var$load("2tJBJ"),
    $e65970f75ad80b7e$var$load("8ORDr"),
    $e65970f75ad80b7e$var$load("4m45y"),
    $e65970f75ad80b7e$var$load("52ZTT"),
    $e65970f75ad80b7e$var$load("9VG8E"),
    $e65970f75ad80b7e$var$load("4AElS"),
    $e65970f75ad80b7e$var$load("iZiYW"),
    $e65970f75ad80b7e$var$load("57o6G"),
    $e65970f75ad80b7e$var$load("1cQg7"),
    $e65970f75ad80b7e$var$load("hs6P3"),
    $e65970f75ad80b7e$var$load("59hV4"),
    $e65970f75ad80b7e$var$load("kwaPJ"),
    $e65970f75ad80b7e$var$load("3ayyN"),
    $e65970f75ad80b7e$var$load("h1yOv"),
    $e65970f75ad80b7e$var$load("aLwQm"),
    $e65970f75ad80b7e$var$load("gfZAh"),
    $e65970f75ad80b7e$var$load("kE76L"),
    $e65970f75ad80b7e$var$load("4x9Jx"),
    $e65970f75ad80b7e$var$load("kHXvF"),
    $e65970f75ad80b7e$var$load("6wr18"),
    $e65970f75ad80b7e$var$load("7gL7H"),
    $e65970f75ad80b7e$var$load("ea3NB"),
    $e65970f75ad80b7e$var$load("euTFt"),
    $e65970f75ad80b7e$var$load("a6HaF"),
    $e65970f75ad80b7e$var$load("h9mwG"),
    $e65970f75ad80b7e$var$load("excC5"),
    $e65970f75ad80b7e$var$load("by9qp"),
    $e65970f75ad80b7e$var$load("i6gwF"),
    $e65970f75ad80b7e$var$load("aLbuU"),
    $e65970f75ad80b7e$var$load("fuOfV"),
    $e65970f75ad80b7e$var$load("jL1Ke"),
    $e65970f75ad80b7e$var$load("5MQ0D"),
    $e65970f75ad80b7e$var$load("6vqGz"),
    $e65970f75ad80b7e$var$load("ffEVr"),
    $e65970f75ad80b7e$var$load("aC3bY"),
    $e65970f75ad80b7e$var$load("jzSMU"),
    $e65970f75ad80b7e$var$load("d8SWd"),
    $e65970f75ad80b7e$var$load("dEUQZ"),
    $e65970f75ad80b7e$var$load("fGNl7"),
    $e65970f75ad80b7e$var$load("hn3wf"),
    $e65970f75ad80b7e$var$load("d8Sxi"),
    $e65970f75ad80b7e$var$load("kGmwI"),
    $e65970f75ad80b7e$var$load("h4Nf7"),
    $e65970f75ad80b7e$var$load("Wowvf"),
    $e65970f75ad80b7e$var$load("lkxmG"),
    $e65970f75ad80b7e$var$load("dFbDj"),
    $e65970f75ad80b7e$var$load("7EorR"),
    $e65970f75ad80b7e$var$load("4UHov"),
    $e65970f75ad80b7e$var$load("hhss7"),
    $e65970f75ad80b7e$var$load("kT6dz"),
    $e65970f75ad80b7e$var$load("aAWLw"),
    $e65970f75ad80b7e$var$load("1D35j")
]).then(()=>parcelRequire('bDbwM'));

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("cXk0q", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6FBXU = parcelRequire("6FBXU");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $3WUt7 = parcelRequire("3WUt7");

const $8b4cd8637684b33c$export$4aa63971c7cdd461 = (0, $6FBXU.default);
const $8b4cd8637684b33c$export$3a7ba9dcd3d890e8 = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { macroDefaultProps: macroDefaultProps, macroParams: macroParams } = t0;
    const [pageIndex, setPageIndex] = (0, $cozmU.useState)(0);
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setPageIndex(0);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== macroParams) {
        t2 = [
            macroParams
        ];
        $[1] = macroParams;
        $[2] = t2;
    } else t2 = $[2];
    (0, $cozmU.useEffect)(t1, t2);
    let isPDFExport;
    let t3;
    let t4;
    let t5;
    if ($[3] !== location?.pathname || $[4] !== macroDefaultProps.attributes?.macroId || $[5] !== macroDefaultProps.contentId || $[6] !== macroDefaultProps.spaceKey || $[7] !== macroParams || $[8] !== pageIndex) {
        isPDFExport = location?.pathname.startsWith("/wiki/pdf/");
        t4 = (0, $jMyy4.useQueryInterop);
        t5 = $8b4cd8637684b33c$export$4aa63971c7cdd461;
        t3 = (0, $3WUt7.buildDetailsSummaryVariables)({
            macroParams: macroParams,
            contentId: macroDefaultProps.contentId,
            spaceKey: macroDefaultProps.spaceKey,
            macroId: macroDefaultProps?.attributes?.macroId?.toString() || "",
            pageIndex: pageIndex,
            isPDFExport: isPDFExport
        });
        $[3] = location?.pathname;
        $[4] = macroDefaultProps.attributes?.macroId;
        $[5] = macroDefaultProps.contentId;
        $[6] = macroDefaultProps.spaceKey;
        $[7] = macroParams;
        $[8] = pageIndex;
        $[9] = isPDFExport;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else {
        isPDFExport = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
    }
    let t6;
    if ($[13] !== t3) {
        t6 = {
            variables: t3,
            fetchPolicy: "cache-first"
        };
        $[13] = t3;
        $[14] = t6;
    } else t6 = $[14];
    const { data: data, error: error, loading: loading } = t4(t5, t6);
    const isInitialLoad = loading && !data;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (_, pageNumber)=>{
            setPageIndex(pageNumber - 1);
        };
        $[15] = t7;
    } else t7 = $[15];
    const paginateTable = t7;
    const t8 = data?.detailsLines?.totalPages || 0;
    let t9;
    if ($[16] !== data || $[17] !== error || $[18] !== isInitialLoad || $[19] !== isPDFExport || $[20] !== loading || $[21] !== pageIndex || $[22] !== t8) {
        t9 = {
            data: data,
            error: error,
            loading: loading,
            isInitialLoad: isInitialLoad,
            isPDFExport: isPDFExport,
            pageIndex: pageIndex,
            paginateTable: paginateTable,
            totalPages: t8
        };
        $[16] = data;
        $[17] = error;
        $[18] = isInitialLoad;
        $[19] = isPDFExport;
        $[20] = loading;
        $[21] = pageIndex;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
module.exports["DetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$4aa63971c7cdd461;
module.exports["useDetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$3a7ba9dcd3d890e8;

});

parcelRegister("6FBXU", function(module, exports) {
/**
 * @generated SignedSource<<61b269fc5c97af6ef6d28bc446a0eec0>>
 * @relayHash 81e0ec3084120c0be1f11ccafd133340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a
const $fa83278cc1200055$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": "atlas_doc_format",
        "kind": "LocalArgument",
        "name": "contentRepresentation"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countComments"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countLikes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countUnresolvedComments"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "detailsId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "headings"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "macroId"
    }, v9 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "pageIndex"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSize"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reverseSort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showCreator"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showLastModified"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showPageLabels"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v17 = {
        "kind": "ScalarField",
        "name": "macroId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentRepresentation",
                    "variableName": "contentRepresentation"
                },
                {
                    "kind": "Variable",
                    "name": "countComments",
                    "variableName": "countComments"
                },
                {
                    "kind": "Variable",
                    "name": "countLikes",
                    "variableName": "countLikes"
                },
                {
                    "kind": "Variable",
                    "name": "countUnresolvedComments",
                    "variableName": "countUnresolvedComments"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "detailsId",
                    "variableName": "detailsId"
                },
                {
                    "kind": "Variable",
                    "name": "headings",
                    "variableName": "headings"
                },
                {
                    "kind": "Variable",
                    "name": "macroId",
                    "variableName": "macroId"
                },
                {
                    "kind": "Variable",
                    "name": "pageIndex",
                    "variableName": "pageIndex"
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                },
                {
                    "kind": "Variable",
                    "name": "reverseSort",
                    "variableName": "reverseSort"
                },
                {
                    "kind": "Variable",
                    "name": "showCreator",
                    "variableName": "showCreator"
                },
                {
                    "kind": "Variable",
                    "name": "showLastModified",
                    "variableName": "showLastModified"
                },
                {
                    "kind": "Variable",
                    "name": "showPageLabels",
                    "variableName": "showPageLabels"
                },
                {
                    "kind": "Variable",
                    "name": "sortBy",
                    "variableName": "sortBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "DetailsSummaryLines",
            "kind": "LinkedField",
            "name": "detailsLines",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalPages"
                },
                {
                    "kind": "ScalarField",
                    "name": "renderedHeadings"
                },
                v17 /*: any*/ ,
                {
                    "concreteType": "DetailLine",
                    "kind": "LinkedField",
                    "name": "detailLines",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relativeLink"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "details"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rowId"
                        },
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "unresolvedCommentsCount"
                        },
                        {
                            "concreteType": "DetailLabels",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayTitle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlPath"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailCreator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailLastModified",
                            "kind": "LinkedField",
                            "name": "lastModified",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyModificationDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sortableDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v16 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ 
        },
        "params": {
            "cacheID": "81e0ec3084120c0be1f11ccafd133340",
            "id": "d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a",
            "metadata": {},
            "name": "useDetailsSummaryADFQueryQuery",
            "operationKind": "query",
            "text": "query useDetailsSummaryADFQueryQuery($cql:String,$detailsId:String,$sortBy:String,$reverseSort:Boolean,$spaceKey:String!,$contentId:ID!,$pageSize:Int,$pageIndex:Int=0,$countComments:Boolean,$countUnresolvedComments:Boolean,$countLikes:Boolean,$showPageLabels:Boolean,$showLastModified:Boolean,$showCreator:Boolean,$headings:String,$contentRepresentation:String=\"atlas_doc_format\",$macroId:String){detailsLines(cql:$cql,detailsId:$detailsId,sortBy:$sortBy,reverseSort:$reverseSort,spaceKey:$spaceKey,contentId:$contentId,pageSize:$pageSize,pageIndex:$pageIndex,countComments:$countComments,countUnresolvedComments:$countUnresolvedComments,countLikes:$countLikes,showPageLabels:$showPageLabels,showLastModified:$showLastModified,showCreator:$showCreator,headings:$headings,contentRepresentation:$contentRepresentation,macroId:$macroId){currentPage,totalPages,renderedHeadings,macroId,detailLines{id,title,relativeLink,details,reactionsCount,commentsCount,rowId,macroId,unresolvedCommentsCount,labels{name,displayTitle,urlPath},creator{name,accountId},lastModified{friendlyModificationDate,sortableDate}}}}"
        }
    };
}();
$fa83278cc1200055$var$node.hash = "e2f904ef103ed055ad0661a39595ea5b";
var $fa83278cc1200055$export$2e2bcd8739ae039 = $fa83278cc1200055$var$node;
module.exports["default"] = $fa83278cc1200055$export$2e2bcd8739ae039;

});

parcelRegister("3WUt7", function(module, exports) {

var $isgNA = parcelRequire("isgNA");

const $2969a01dbaf01c74$var$isTrue = (params, key)=>params?.[key]?.value === 'true';
const $2969a01dbaf01c74$var$normalizeCql = (cql)=>{
    return cql?.trim() ? cql : undefined;
};
/**
 * Resolve the effective `pageSize` query variable for the details-summary
 * macro.
 *
 * Rules (kept in one place so the runtime hook, the SSR preload-macros
 * handler, and the legacy SSR preload all behave identically):
 *
 * - When rendering inside a PDF export, always request the maximum page size
 *   (`MAX_PDF_PAGE_SIZE`) so the exported document contains every row.
 * - Otherwise, parse the user-supplied `pageSize` macro param as a base-10
 *   integer. Missing / unparseable values fall back to the default
 *   (`DEFAULT_MAX_PAGE_SIZE`).
 * - The parsed value is then clamped to `DEFAULT_MAX_PAGE_SIZE` so a macro
 *   author cannot accidentally request a larger page than the server is
 *   tuned for.
 */ const $2969a01dbaf01c74$var$resolvePageSize = (macroParams, isPDFExport)=>{
    if (isPDFExport) return 0, $isgNA.MAX_PDF_PAGE_SIZE;
    const rawValue = macroParams?.['pageSize']?.value;
    const parsed = parseInt(rawValue || `${0, $isgNA.DEFAULT_MAX_PAGE_SIZE}`, 10);
    if (Number.isNaN(parsed)) return 0, $isgNA.DEFAULT_MAX_PAGE_SIZE;
    return Math.min(parsed, (0, $isgNA.DEFAULT_MAX_PAGE_SIZE));
};
const $2969a01dbaf01c74$export$1b64d6545318c754 = ({ macroParams: macroParams, contentId: contentId, spaceKey: spaceKey, macroId: macroId, pageIndex: pageIndex = 0, isPDFExport: isPDFExport = false })=>({
        // `_parentId` is the source page where the macro was inserted; it is
        // present when nested inside of other macros and should be used instead of
        // the current page contentId.
        contentId: macroParams?.['_parentId']?.value || contentId,
        cql: $2969a01dbaf01c74$var$normalizeCql(macroParams?.['cql']?.value),
        detailsId: macroParams?.['id']?.value,
        headings: macroParams?.['headings']?.value,
        sortBy: macroParams?.['sortBy']?.value,
        spaceKey: spaceKey,
        countLikes: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLikesCount'),
        reverseSort: $2969a01dbaf01c74$var$isTrue(macroParams, 'reverseSort'),
        countComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCommentsCount'),
        countUnresolvedComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showUnresolvedCommentsCount'),
        showPageLabels: $2969a01dbaf01c74$var$isTrue(macroParams, 'showPageLabels'),
        showLastModified: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLastModified'),
        showCreator: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCreator'),
        pageIndex: pageIndex,
        macroId: macroId,
        pageSize: $2969a01dbaf01c74$var$resolvePageSize(macroParams, isPDFExport)
    });
module.exports["buildDetailsSummaryVariables"] = $2969a01dbaf01c74$export$1b64d6545318c754;

});

parcelRegister("isgNA", function(module, exports) {
const $38e46c834876fccf$export$38d4334417be6de4 = [
    'showCreator',
    'showLastModified',
    'showPageLabels',
    'showCommentsCount',
    'showUnresolvedCommentsCount',
    'showLikesCount'
];
const $38e46c834876fccf$export$89486cb0536270a1 = 30;
const $38e46c834876fccf$export$bcb403f7710dd1db = 500;
module.exports["optionalTableHeaderParams"] = $38e46c834876fccf$export$38d4334417be6de4;
module.exports["DEFAULT_MAX_PAGE_SIZE"] = $38e46c834876fccf$export$89486cb0536270a1;
module.exports["MAX_PDF_PAGE_SIZE"] = $38e46c834876fccf$export$bcb403f7710dd1db;

});

parcelRegister("at1wf", function(module, exports) {

var $4XbfY = parcelRequire("4XbfY");


var $iNGf0 = parcelRequire("iNGf0");

class $64cd2f6919e64ab9$export$2e2bcd8739ae039 {
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $iNGf0.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $4XbfY.defaultSchema)) {
        return new $64cd2f6919e64ab9$export$2e2bcd8739ae039(schema);
    }
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
}
module.exports["default"] = $64cd2f6919e64ab9$export$2e2bcd8739ae039;

});

parcelRegister("iNGf0", function(module, exports) {

var $6of4U = parcelRequire("6of4U");


var $ieVrh = parcelRequire("ieVrh");


var $bJSXd = parcelRequire("bJSXd");


var $6IJk5 = parcelRequire("6IJk5");


var $63z7w = parcelRequire("63z7w");


var $Vlxg4 = parcelRequire("Vlxg4");


var $1K7J8 = parcelRequire("1K7J8");


var $52f9Q = parcelRequire("52f9Q");


var $hxitp = parcelRequire("hxitp");


var $6KCHO = parcelRequire("6KCHO");


var $44pQv = parcelRequire("44pQv");


var $9gbbf = parcelRequire("9gbbf");


var $j7mJN = parcelRequire("j7mJN");


var $kxYoQ = parcelRequire("kxYoQ");


var $a9rhS = parcelRequire("a9rhS");


var $jFg0g = parcelRequire("jFg0g");


var $1BnGB = parcelRequire("1BnGB");


var $b49IO = parcelRequire("b49IO");

const $9a113cebc8804ae1$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $9a113cebc8804ae1$var$nodeToReducerMapping[node.type.name] || $9a113cebc8804ae1$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $9a113cebc8804ae1$var$nodeToReducerMapping = {
    blockquote: $6of4U.default,
    bulletList: $ieVrh.default,
    date: $bJSXd.default,
    decisionItem: $6IJk5.default,
    hardBreak: $63z7w.default,
    heading: $Vlxg4.default,
    inlineCard: $1K7J8.default,
    listItem: $52f9Q.default,
    mediaGroup: $hxitp.default,
    mention: $6KCHO.default,
    orderedList: $44pQv.default,
    panel: $9gbbf.default,
    panel_c1: (0, $9gbbf.default),
    paragraph: $j7mJN.default,
    rule: $kxYoQ.default,
    status: $a9rhS.default,
    table: $jFg0g.default,
    taskItem: $1BnGB.default,
    unknown: $b49IO.default
};
module.exports["reduce"] = $9a113cebc8804ae1$export$533b26079ad0b4b;

});

parcelRegister("6of4U", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $fd93b6cc3e3ae127$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $fd93b6cc3e3ae127$export$2e2bcd8739ae039 = $fd93b6cc3e3ae127$var$blockquote;
module.exports["default"] = $fd93b6cc3e3ae127$export$2e2bcd8739ae039;

});

parcelRegister("ieVrh", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $7148a3dfac9fb0b6$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $iNGf0.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $7148a3dfac9fb0b6$export$2e2bcd8739ae039 = $7148a3dfac9fb0b6$var$bulletList;
module.exports["default"] = $7148a3dfac9fb0b6$export$2e2bcd8739ae039;

});

parcelRegister("bJSXd", function(module, exports) {

var $efgwK = parcelRequire("efgwK");


var $6FNab = parcelRequire("6FNab");

const $abf445e85d320cb8$var$date = (node, _schema)=>{
    return node.attrs.timestamp ? (0, $efgwK.timestampToIsoFormat)(node.attrs.timestamp) : (0, $6FNab.getText)(node);
};
var $abf445e85d320cb8$export$2e2bcd8739ae039 = $abf445e85d320cb8$var$date;
module.exports["default"] = $abf445e85d320cb8$export$2e2bcd8739ae039;

});

parcelRegister("6IJk5", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $db9079b38a40c947$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $iNGf0.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $db9079b38a40c947$export$2e2bcd8739ae039 = $db9079b38a40c947$var$decisionItem;
module.exports["default"] = $db9079b38a40c947$export$2e2bcd8739ae039;

});

parcelRegister("63z7w", function(module, exports) {
const $21efdb95e5ccf897$var$hardBreak = ()=>{
    return '\n';
};
var $21efdb95e5ccf897$export$2e2bcd8739ae039 = $21efdb95e5ccf897$var$hardBreak;
module.exports["default"] = $21efdb95e5ccf897$export$2e2bcd8739ae039;

});

parcelRegister("Vlxg4", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $f85fe34da5fc5487$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('');
};
var $f85fe34da5fc5487$export$2e2bcd8739ae039 = $f85fe34da5fc5487$var$heading;
module.exports["default"] = $f85fe34da5fc5487$export$2e2bcd8739ae039;

});

parcelRegister("1K7J8", function(module, exports) {

var $6FNab = parcelRequire("6FNab");

const $70f547b653171850$var$inlineCard = (node, _schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $6FNab.getText)(node);
};
var $70f547b653171850$export$2e2bcd8739ae039 = $70f547b653171850$var$inlineCard;
module.exports["default"] = $70f547b653171850$export$2e2bcd8739ae039;

});

parcelRegister("52f9Q", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $d669454d48ed6f9d$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('\n');
};
var $d669454d48ed6f9d$export$2e2bcd8739ae039 = $d669454d48ed6f9d$var$listItem;
module.exports["default"] = $d669454d48ed6f9d$export$2e2bcd8739ae039;

});

parcelRegister("hxitp", function(module, exports) {
const $db1b3432a92b30e7$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $db1b3432a92b30e7$export$2e2bcd8739ae039 = $db1b3432a92b30e7$var$mediaGroup;
module.exports["default"] = $db1b3432a92b30e7$export$2e2bcd8739ae039;

});

parcelRegister("6KCHO", function(module, exports) {
const $2892b7520cfa40c3$var$mention = (node, _schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $2892b7520cfa40c3$export$2e2bcd8739ae039 = $2892b7520cfa40c3$var$mention;
module.exports["default"] = $2892b7520cfa40c3$export$2e2bcd8739ae039;

});

parcelRegister("44pQv", function(module, exports) {

var $eTXkv = parcelRequire("eTXkv");


var $iNGf0 = parcelRequire("iNGf0");

const $d92c4e65e81f46d9$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $eTXkv.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $iNGf0.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d92c4e65e81f46d9$export$2e2bcd8739ae039 = $d92c4e65e81f46d9$var$orderedList;
module.exports["default"] = $d92c4e65e81f46d9$export$2e2bcd8739ae039;

});

parcelRegister("9gbbf", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $d6ca89f5f43e07e1$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('\n');
};
var $d6ca89f5f43e07e1$export$2e2bcd8739ae039 = $d6ca89f5f43e07e1$var$panel;
module.exports["default"] = $d6ca89f5f43e07e1$export$2e2bcd8739ae039;

});

parcelRegister("j7mJN", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $5d93a0ec0675b7e1$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $iNGf0.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $5d93a0ec0675b7e1$export$2e2bcd8739ae039 = $5d93a0ec0675b7e1$var$paragraph;
module.exports["default"] = $5d93a0ec0675b7e1$export$2e2bcd8739ae039;

});

parcelRegister("kxYoQ", function(module, exports) {
const $e07e0bacdcac7501$var$rule = ()=>{
    return '';
};
var $e07e0bacdcac7501$export$2e2bcd8739ae039 = $e07e0bacdcac7501$var$rule;
module.exports["default"] = $e07e0bacdcac7501$export$2e2bcd8739ae039;

});

parcelRegister("a9rhS", function(module, exports) {

var $6FNab = parcelRequire("6FNab");


var $iDrrr = parcelRequire("iDrrr");

const $fb5e716dbb959b0a$var$status = (node, _schema)=>{
    return node.attrs.text ? node.attrs.style === 'mixedCase' && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? `[ ${node.attrs.text} ]` : `[ ${node.attrs.text.toUpperCase()} ]` : (0, $6FNab.getText)(node);
};
var $fb5e716dbb959b0a$export$2e2bcd8739ae039 = $fb5e716dbb959b0a$var$status;
module.exports["default"] = $fb5e716dbb959b0a$export$2e2bcd8739ae039;

});

parcelRegister("jFg0g", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $7d27d5632f61f2e0$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($7d27d5632f61f2e0$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $7d27d5632f61f2e0$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($7d27d5632f61f2e0$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $7d27d5632f61f2e0$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('\n');
};
var $7d27d5632f61f2e0$export$2e2bcd8739ae039 = $7d27d5632f61f2e0$var$table;
module.exports["default"] = $7d27d5632f61f2e0$export$2e2bcd8739ae039;

});

parcelRegister("1BnGB", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $763eeae6bd63480d$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $iNGf0.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $763eeae6bd63480d$export$2e2bcd8739ae039 = $763eeae6bd63480d$var$taskItem;
module.exports["default"] = $763eeae6bd63480d$export$2e2bcd8739ae039;

});

parcelRegister("b49IO", function(module, exports) {

var $6FNab = parcelRequire("6FNab");


var $iNGf0 = parcelRequire("iNGf0");

const $f5667c3ba2e27106$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $6FNab.getText)(node);
};
var $f5667c3ba2e27106$export$2e2bcd8739ae039 = $f5667c3ba2e27106$var$unknown;
module.exports["default"] = $f5667c3ba2e27106$export$2e2bcd8739ae039;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});


//# sourceMappingURL=PagePropertiesReportRenderer.5aec27aa.js.map
